<template>
<span>
  <slot v-on:click="run">
    <b-tooltip label="Download as PDF" v-show="!running">
      <a href="#_" v-on:click="run">
        <b-icon
          pack="fas"
          icon="file-pdf"
        />
      </a>
    </b-tooltip>
  </slot>
  <b-icon
    pack="fas"
    icon="circle-notch"
    class="fa-spin is-primary"
    v-show="running"
  />
</span>
</template>

<script>
  import ReportActionMixin from '@frontend/dash3/js/components/reportbuilder/ReportActionMixin.js';
  export default {
    data() {
      return {
        action: 'download_pdf',
        shouldDownload: true,
      }
    },
    mixins: [ReportActionMixin],
  }
</script>

<style scoped>
</style>
